import styled from 'styled-components';

export const UserListStyles = styled('div')`
  .status-actions {
    top: 38px !important;
  }
`;
